import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppModule } from '../../../app-module';

@Component({
  selector: 'oaj-modal-image-itx',
  templateUrl: './modal-image.component.html',
  styleUrls: ['./modal-image.component.css'],
  imports: [AppModule]
})
export class ModalImageComponent {

  @Input()
  titulo!: string;
  @Input()
  imageUrl!: string;
  @Input()
  downloadFileName!: string;

  private activeModal: NgbActiveModal = inject(NgbActiveModal);

  public close() {
    this.activeModal.close(true);
  }

  public downloadImage() {
    // Crear un nuevo objeto de imagen
    const img = new Image();
    img.crossOrigin = 'anonymous'; // Intentar acceso CORS
    
    img.onload = () => {
      // Crear un canvas del mismo tamaño que la imagen
      const canvas = document.createElement('canvas');
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      
      // Dibujar la imagen en el canvas
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.drawImage(img, 0, 0);
        
        // Convertir el canvas a blob y descargar
        canvas.toBlob((blob) => {
          if (blob) {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = this.downloadFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }
        }, 'image/png');
      }
    };
    
    img.onerror = () => {
      // Si falla, intentar descarga directa o abrir en nueva pestaña
      console.warn('No se pudo procesar la imagen, intentando descarga directa...');
      const link = document.createElement('a');
      link.href = this.imageUrl;
      link.download = this.downloadFileName;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
    
    // Cargar la imagen
    img.src = this.imageUrl;
  }
}